import { render, staticRenderFns } from "./SubpageNotificationDevices.vue?vue&type=template&id=5f4ed4ba&scoped=true&"
import script from "./SubpageNotificationDevices.vue?vue&type=script&lang=js&"
export * from "./SubpageNotificationDevices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f4ed4ba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/bamboo-agent-home/xml-data/build-dir/WWW-WWW-JOB1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f4ed4ba')) {
      api.createRecord('5f4ed4ba', component.options)
    } else {
      api.reload('5f4ed4ba', component.options)
    }
    module.hot.accept("./SubpageNotificationDevices.vue?vue&type=template&id=5f4ed4ba&scoped=true&", function () {
      api.rerender('5f4ed4ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/components/myaccount/notifications/SubpageNotificationDevices.vue"
export default component.exports